import { rem } from '@blueprint/ui';

import { Box, Link, Icon, Typography } from 'components/blueprint';
import { useSafeLabel } from 'hooks';
import { useInteractionTracking } from 'tracking/hooks/useInteractionTracking';

import messages from './messages';

/**
 * Breadcrumb
 * top breadcrumb
 */
export const Breadcrumbs = ({ breadcrumb = [], onNavContextChange }) => {
  const safeLabel = useSafeLabel();
  const trackBreadcrumbs = useInteractionTracking('button click');

  const handleNavContextChange = (e, item) => {
    e.preventDefault();
    onNavContextChange(item.navcontext);
  };

  return (
    <>
      {breadcrumb.length === 1 && (
        <Typography variant="body1">{safeLabel(messages.topFaqs)}</Typography>
      )}
      <Box as="ol" paddingLeft={0} margin={0}>
        {breadcrumb?.length > 1 &&
          breadcrumb.map((item, i) => (
            <Box
              as="li"
              display="inline-block"
              key={item.navcontext}
              lineHeight={rem(25)}
              aria-current={i < breadcrumb.length - 1 ? undefined : 'true'}
            >
              {i < breadcrumb.length - 1 ? (
                item.displaycontext === 'Root' ? (
                  <Link
                    onClick={trackBreadcrumbs({
                      onClick: (e) => handleNavContextChange(e, item),
                      tealiumData: {
                        event_content: 'category breadcrumb: top faqs',
                      },
                    })}
                    underline
                    variant="body1"
                    marginLeft={rem(5)}
                    tabIndex={0}
                    href="#"
                  >
                    {safeLabel(messages.topFaqs)}
                    <Icon
                      name="ChevronRight"
                      size={12}
                      left={rem(5)}
                      top={rem(2)}
                    />
                  </Link>
                ) : (
                  <Link
                    marginX={rem(10)}
                    onClick={trackBreadcrumbs({
                      onClick: (e) => handleNavContextChange(e, item),
                      tealiumData: {
                        event_content: `category breadcrumb: ${item.displaycontext.toLowerCase()}`,
                      },
                    })}
                    underline
                    tabIndex={0}
                    href="#"
                  >
                    {item.displaycontext}
                    <Icon
                      name="ChevronRight"
                      size={rem(12)}
                      left={rem(5)}
                      top={rem(2)}
                    />
                  </Link>
                )
              ) : (
                <Typography underline marginX={rem(5)}>
                  {item.displaycontext}
                </Typography>
              )}
            </Box>
          ))}
      </Box>
    </>
  );
};
